import Pagination from '@material-ui/lab/Pagination';
import { Badge, DatePicker, Form, Input, Space, Select, InputNumber } from 'antd';
import _ from 'lodash';
import React, { Suspense, useEffect, useState } from "react";
import {
    //  FormattedMessage, 
    injectIntl
} from "react-intl";
import { withRouter } from "react-router-dom";
import ActionEditDelete from '../../../components/ActionEditDelete';
import CustomButton from '../../../components/CustomButton';
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody
} from "../../../_metronic/_partials/controls";
import DetailSwapHNG from './DetailSwapHNG';

import moment from "moment";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    actionGetListHistorySwapCoin,
    actionGetListHistorySwapUSD
} from '../../../redux/transaction/actions';
import {
    formatCoin,
    formatCoinID,
    formatMoney
} from '../../lib/common';
import { CaretDownOutlined } from '@ant-design/icons';
import * as TYPE from '../../lib/contrant';
import DetailSwapUSD from './DetailSwapUSD';

const { RangePicker } = DatePicker;
const formRef = React.createRef()
function ListSellUSDT(props) {
    const suhbeader = useSubheader();
    const [visibleSearch, setVisibleSearch] = useState(false)
    const [visible, setVisible] = useState(false);
    const [checkbox, setCheckbox] = useState([]);
    const [visibleModalDetail, setVisibleModalDetail] = useState(false)
    const [recordModal, setRecordModal] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const [date, setDate] = useState([null, null])

    const { intl } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.LIST_SELL_USDT' }));
    const dispatch = useDispatch();
    const { dataSwapUSD, listUserLoginPermission } = useSelector(state => ({
        dataSwapUSD: state.transactionReducer.dataSwapUSD,
        listUserLoginPermission: state.authReducer.listUserLoginPermission
    }), shallowEqual)

    const [totalMoneyBuy, setTotalMoneyBuy] = useState(dataSwapUSD.sumMoneyBuy || 0);
    const [totalMoneySell, setTotalMoneySell] = useState(dataSwapUSD.sumMoneySell || 0);
    const [totalUSDBuy, setTotalUSDBuy] = useState(dataSwapUSD.sumUSDBuy || 0);
    const [totalUSDSell, setTotalUSDSell] = useState(dataSwapUSD.sumUSDSell || 0);
    useEffect(() => {
        (async () => {
            // if (listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_USD)) {
                let swapVNDUSD = await dispatch(actionGetListHistorySwapUSD({ page: 1, type: 'swap_USDT_VNĐ' }));
                setTotalMoneyBuy(swapVNDUSD.sumMoneyBuy)
                setTotalMoneySell(swapVNDUSD.sumMoneySell)
                setTotalUSDBuy(swapVNDUSD.sumUSDBuy)
                setTotalUSDSell(swapVNDUSD.sumUSDSell)
            // } else {
            //     let dataReq = await dispatch(actionGetListHistorySwapUSD({ page: 1 }));
            //     setTotalMoneyBuy(dataReq.sumMoneyBuy)
            //     setTotalMoneySell(dataReq.sumMoneySell)
            //     setTotalUSDBuy(dataReq.sumUSDBuy)
            //     setTotalUSDSell(dataReq.sumUSDSell)
            // }
        })()
    }, [])

    const onChangePage = async (_, page) => {
        let { user_name_source, user_name_destination, transactionID, email, mobile, type, start, end, start_usd, end_usd, start_money, end_money, vip, type_user } = formRef.current.getFieldsValue()
        let filter = {
        }
        if (email)
            filter.email = email.trim()
        if (type) {
            filter.type = type
        }
        if (start) {
            filter.start = start
        }
        if (end) {
            filter.end = end
        }
        if (start_usd) {
            filter.start_usd = start_usd
        }
        if (end_usd) {
            filter.end_usd = end_usd
        }
        if (start_money) {
            filter.start_money = start_money
        }
        if (end_money) {
            filter.end_money = end_money
        }
        if (mobile)
            filter.mobile = mobile.trim()
        if (type_user !== '')
            filter.type_user = type_user
        if (vip)
            filter.vip = vip
        if (date && date.length > 0 && date[0]) {
            filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        await dispatch(actionGetListHistorySwapUSD({ ...filter, page, type: 'swap_USDT_VNĐ', user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '' }));
    }
    const onChangeDateRange = async (e) => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_usd, end_usd, start_money, end_money, vip, type_user } = formRef.current.getFieldsValue()
        let data_filter = {}
        if (type) {
            data_filter.type = type
        }
        if (start) {
            data_filter.start = start
        }
        if (start_usd) {
            data_filter.start_usd = start_usd
        }
        if (end_usd) {
            data_filter.end_usd = end_usd
        }
        if (start_money) {
            data_filter.start_money = start_money
        }
        if (end_money) {
            data_filter.end_money = end_money
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        if (type_user)
            data_filter.type_user = type_user
        if (vip)
            data_filter.vip = vip
        if (e && e.length > 1) {
            let dataReq = await dispatch(actionGetListHistorySwapUSD({ date: [moment(e[0]).format('YYYY/MM/DD'), moment(e[1]).format('YYYY/MM/DD')], page: 1, type: 'swap_USDT_VNĐ', user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            setTotalMoneyBuy(dataReq.sumMoneyBuy)
            setTotalMoneySell(dataReq.sumMoneySell)
            setTotalUSDBuy(dataReq.sumUSDBuy)
            setTotalUSDSell(dataReq.sumUSDSell)
            setDate(e)
        }
        else {
            let dataReq = await dispatch(actionGetListHistorySwapUSD({ page: 1, type: 'swap_USDT_VNĐ', user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            setTotalMoneyBuy(dataReq.sumMoneyBuy)
            setTotalMoneySell(dataReq.sumMoneySell)
            setTotalUSDBuy(dataReq.sumUSDBuy)
            setTotalUSDSell(dataReq.sumUSDSell)
        }

    };

    const onSearchDelayed = _.debounce(() => onSearch(), 100)
    const onSearch = async () => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_usd, end_usd, start_money, end_money, vip, type_user } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        let data_filter = { user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '' }
        if (date[0] && date[1]) {
            data_filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        if (type) {
            data_filter.type = type
        }
        if (start) {
            data_filter.start = start
        }
        if (start_usd) {
            data_filter.start_usd = start_usd
        }
        if (end_usd) {
            data_filter.end_usd = end_usd
        }
        if (start_money) {
            data_filter.start_money = start_money
        }
        if (end_money) {
            data_filter.end_money = end_money
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        if (type_user !== '')
            data_filter.type_user = type_user
        if (vip)
            data_filter.vip = vip
        let dataReq = await dispatch(actionGetListHistorySwapUSD({type: 'swap_USDT_VNĐ', ...data_filter}));
        setTotalMoneyBuy(dataReq.sumMoneyBuy)
        setTotalMoneySell(dataReq.sumMoneySell)
        setTotalUSDBuy(dataReq.sumUSDBuy)
        setTotalUSDSell(dataReq.sumUSDSell)
        setVisible(false)
    }
    const renderStatus = (status) => {
        switch (status) {
            case 0: {
                return (
                    <Badge status="warning" text='Chờ' />
                )
            }
            case 1: {
                return (
                    <Badge status="processing" text='Thành công' />
                )
            }
            case 2: {
                return (
                    <Badge status="success" text='Hoàn thành' />
                )
            }
            case -1: {
                return (
                    <Badge status="error" text='Ngừng giao dịch' />
                )
            }
            default:
                break;
        }
    }
    const closeDetail = () => {
        setRecordModal(null)
        setFilterModal(null)
        setVisibleModalDetail(false)
    }
    const onOpenModal = (dataEdit) => {
        if (!dataEdit)
            setRecordModal(null)
        else
            setRecordModal(dataEdit)

        setFilterModal({
            name: dataSwapUSD?.row?.user?.name,
            page: dataSwapUSD?.paging?.page
        })
        setVisibleModalDetail(true)
    }
    const closeModal = async () => {
        setCheckbox([])
        setVisible(false)
    }
    const renderAgency = (level) => {
        switch (level) {
          case 1:
            return "Đại sứ kinh doanh";
          case 2:
            return "Nhượng quyền trực tuyến";
        }
        return "Người dùng";
    };
    const renderBodyTable = () => {
        return dataSwapUSD?.rows?.length > 0
            ? dataSwapUSD.rows.map((it, idx) => {
                return (
                    <tr key={`renderBodyTable_${it.id || idx}`}>
                        <td className="tr-center">
                            {(dataSwapUSD?.paging?.page - 1) * dataSwapUSD?.paging?.limit + idx + 1}
                        </td>
                        <td className="tr-center maxw--200">
                            {it?.transaction_id}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.user?.fullname || "--"}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.user?.level || 0}
                        </td>
                        <td className="tr-center maxw--300">
                            {renderAgency(it?.user?.agency?.level)}
                        </td>
                        <td className="tr-center maxw--300">
                            {it.source_coin_id == 4 ? formatCoin((it?.amount_coin_source), 4) : formatCoin(it?.amount_coin_destination, 4)}
                        </td>
                        <td className="tr-center maxw--300">
                            {`1 USDT = ${formatMoney(it?.exchange_rate || 0)} VNDC`}
                        </td>
                        <td className="tr-center maxw--300">
                            {`${formatMoney((it.source_coin_id == 4 ? Number.parseFloat(it?.amount_coin_source) : Number.parseFloat(it?.amount_coin_destination)) * Number.parseFloat(it?.exchange_rate))}` || 0}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.createdAt ? moment(it?.createdAt).format('DD/MM/YYYY HH:mm:ss') : "Không xác định"}
                        </td>
                        <td className="tr-center maxw--300">
                            {renderStatus(it?.status)}
                        </td>
                        <td className="tr-center maxw--300">
                            <ActionEditDelete
                                OverlayTrigger={true}
                                onclickView={() => onOpenModal(it)}
                                hideDelete={true}
                                hideEdit={true}
                            />
                        </td>
                    </tr>
                )
            })
            : <tr>
                <td className="tr-center" colSpan={12}>Không có dữ liệu hiển thị</td>
            </tr>
    }

    const onClearSearch = async () => {
        formRef.current.setFieldsValue({
            user_name_source: undefined,
            user_name_destination: undefined,
            transactionID: undefined,
            email_source: undefined,
            mobile_source: undefined,
            mobile: undefined,
            email: undefined,
            picker: undefined,
            start_usd: undefined,
            end_usd: undefined,
            start_money: undefined,
            end_money: undefined,
            type: '',
            vip: undefined,
            type_user: ""
        })
        setCheckbox([])
        setDate([null, null])
        setVisibleSearch(false)

        let swapVNDUSD = await dispatch(actionGetListHistorySwapUSD({ page: 1, type: 'swap_USDT_VNĐ' }));
        setTotalMoneyBuy(swapVNDUSD.sumMoneyBuy)
        setTotalMoneySell(swapVNDUSD.sumMoneySell)
        setTotalUSDBuy(swapVNDUSD.sumUSDBuy)
        setTotalUSDSell(swapVNDUSD.sumUSDSell)
    }
    const onExportDelayed = async () => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_usd, end_usd, start_money, end_money, type_user, vip } = formRef.current.getFieldsValue()
        setVisibleSearch(true)

        const url = new URL(`${process.env.REACT_APP_API_URL}/admin/exportExcel/list-swap-usd`);
        const accessToken = localStorage.getItem('token');
        url.searchParams.append("token", accessToken);
        let data_filter = {
            user_name_source: user_name_source ? user_name_source.trim() : '',
            transactionID: transactionID ? transactionID.trim() : '',
            user_name_destination: user_name_destination ? user_name_destination.trim() : '',
            type: 'swap_USDT_VNĐ'
        }
        if (date[0] && date[1]) {
            data_filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        if (type) {
            data_filter.type = type
        }
        if (start_usd) {
            data_filter.start_usd = start_usd
        }
        if (end_usd) {
            data_filter.end_usd = end_usd
        }
        if (start_money) {
            data_filter.start_money = start_money
        }
        if (end_money) {
            data_filter.end_money = end_money
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        if (type_user !== '')
            data_filter.type_user = type_user
        if (vip)
            data_filter.vip = vip
        Object.keys(data_filter).forEach(key => {
            url.searchParams.append(key, data_filter[key]);
        });
        window.open(url);
        // setVisibleSearch(false)
        // onClearSearch()
    }
    const enterKeyPressed = (event) => {
        if (event.keyCode == 13) {
            onSearch()
        }
    }
    return (
        <>
            <Card>
                <CardBody>

                    <Form
                        className="width100"
                        ref={formRef}
                    >
                        <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Mã giao dịch{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="transactionID"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập mã giao dịch"
                                    />
                                </Form.Item>
                            </div>

                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Tên khách hàng{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="user_name_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập tên khách hàng"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Email{` `}
                                </div>
                                <Form.Item
                                    className="email"
                                    name="email_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập email"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    SĐT{` `}
                                </div>
                                <Form.Item
                                    className="mobile"
                                    name="mobile_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập số điện thoại"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Hạng VIP {` `}</div>
                                <Form.Item className="name" name="vip">
                                <Select
                                    placeholder="Chọn hạng VIP"
                                    // defaultValue={""}
                                    className="trongCustomSelect2"
                                    mode="multiple"
                                >
                                    {/* <Select.Option value={""}>Tất cả</Select.Option> */}
                                    <Select.Option value={"0"}>Cấp 0</Select.Option>
                                    <Select.Option value={"1"}>Cấp 1</Select.Option>
                                    <Select.Option value={"2"}>Cấp 2</Select.Option>
                                    <Select.Option value={"3"}>Cấp 3</Select.Option>
                                    <Select.Option value={"4"}>Cấp 4</Select.Option>
                                    <Select.Option value={"5"}>Cấp 5</Select.Option>
                                    <Select.Option value={"6"}>Cấp 6</Select.Option>
                                    <Select.Option value={"7"}>Cấp 7</Select.Option>
                                </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Nhóm người dùng{` `}</div>
                                <Form.Item className="name" name="type_user">
                                <Select
                                    placeholder="Chọn nhóm người dùng"
                                    className="customSelect"
                                    suffixIcon={<CaretDownOutlined />}
                                    defaultValue={""}
                                >
                                    <Select.Option value={""}>Tất cả</Select.Option>
                                    <Select.Option value={0}>Người dùng</Select.Option>
                                    <Select.Option value={1}>Đại sứ kinh doanh</Select.Option>
                                    <Select.Option value={2}>
                                    Nhượng quyền trực tuyến
                                    </Select.Option>
                                </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Thời gian{` `}
                                </div>
                                <Space className='customSpace'>
                                    <Form.Item
                                        name='picker'
                                    >
                                        <RangePicker allowClear onChange={(e) => onChangeDateRange(e)} placeholder={['Từ ngày', 'Đến ngày']} className='customDate' />
                                    </Form.Item>
                                </Space>
                            </div>
                        </div>
                        <div className="mb--20 row-end">
                            <CustomButton
                                className="mr--10"
                                title="Tìm kiếm"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onSearchDelayed}
                            />
                            {visibleSearch && <CustomButton
                                className="customClearSearch mr--10"
                                title="Bỏ lọc"
                                btnBgColor="#eceef7"
                                btnColor="#192038"
                                btnHoverBackground="#eceef7"
                                onClick={onClearSearch}
                            />}
                            <CustomButton
                                className="mr--10"
                                title="Xuất file"
                                btnBgColor="#838d20"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onExportDelayed}
                            />
                        </div>
                        <div className="d-flex space-between col-12">
                            <div className=""><span className="b--700">Tổng số:{' '}</span>{`${formatMoney(dataSwapUSD?.total || 0)}`}</div>
                            <div className=""><span className="b--700">Tổng số USDT:{' '}</span>{`${formatCoinID((totalUSDSell), 4)}`}</div>
                            <div className=""><span className="b--700">Tổng số VNDC:{' '}</span>{`${formatCoinID((totalMoneySell), 1)}`}</div>
                            <div className=""><span className="b--700"></span></div>
                        </div>
                        <div className="trongCustomTableCtn2">
                            <table className="customTable">
                                <tr className="bg-E6F8FD">
                                    <th className="tr-center">STT</th>
                                    <th className="tr-center">Mã giao dịch</th>
                                    <th className="tr-center">Khách hàng</th>
                                    <th className="tr-center">Hạng VIP</th>
                                    <th className="tr-center">Nhóm người dùng</th>
                                    <th className="tr-center">Số lượng (USDT)</th>
                                    <th className="tr-center">Tỉ giá</th>
                                    <th className="tr-center">Số tiền (VNDC)</th>
                                    <th className="tr-center">Thời gian</th>
                                    <th className="tr-center">Trạng thái</th>
                                    <th className="tr-center">Thao tác</th>
                                </tr>
                                {renderBodyTable()}
                            </table>
                        </div>
                        <div className="mt--20 rowx-center">
                            {dataSwapUSD?.paging?.total > dataSwapUSD?.paging?.limit && <div className="mt--20 rowx-center">
                                <Pagination
                                    count={dataSwapUSD?.paging?.count} //total
                                    page={dataSwapUSD?.paging?.page} //current page
                                    variant="outlined" shape="rounded" showFirstButton showLastButton
                                    onChange={(event, page) => onChangePage(event, page)}
                                />
                            </div>}
                        </div>
                    </Form>


                </CardBody>
            </Card>
            <Suspense fallback={<div></div>}>
                <section>
                    {visibleModalDetail && <DetailSwapUSD
                        onCloseModal={closeDetail}
                        visibleModal={visibleModalDetail}
                        recordModal={recordModal}
                        filterModal={filterModal}
                    />}
                </section>
            </Suspense>
        </>
    );
};
export default injectIntl(withRouter(ListSellUSDT));